import React, { useState } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import Input from '../input/input';
import Button from '../button/button';
import Iframe from 'react-iframe'; // Added by Chris to replace MailChimp mailing list subscrition component by Sendinblue iFrame
import {
  NewsletterWrapper,
  NewsletterTitle,
  InputWrapper,
  NewsletterInputWrapper,
  ErrorMessage,
  SuccessMessage,
} from './newsletter.style';

type NewsletterProps = {};

const Newsletter: React.FunctionComponent<NewsletterProps> = ({ ...props }) => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const handleChange = (e: any) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    addToMailchimp(email) // listFields are optional if you are only capturing the email address.
      .then(({ msg, result }: any) => {
        if (result !== 'success') {
          throw msg;
        }
        setSuccess(msg);
        setError('');
        setEmail('');
      })
      .catch((err: any) => {
        setError(err);
        setSuccess('');
        setEmail('');
      });
  };
  return (
    <NewsletterWrapper {...props}>
      <Iframe // Iframe block added by Chris
        url="https://5effdfd2.sibforms.com/serve/MUIEAAbyqcu5vxd312cKo2KGsZKDV5BvsFOn3QPUgYuKWN6C4TG3NFGpOzmuiaVnyLDsvlJfhg6co2_eibuMs2ghkGOxyE0ZtfFwZIfMaQhemF7JfdYu_D4-a2JxKoIjFo6Li5tlH22EMCYl3MftybsYmF3A3VXtsqIgR9WtOEjO9AKXXa-_LBkEGK5btM02aWf-ls7cOmOxIJD1"
        src="https://5effdfd2.sibforms.com/serve/MUIEAAbyqcu5vxd312cKo2KGsZKDV5BvsFOn3QPUgYuKWN6C4TG3NFGpOzmuiaVnyLDsvlJfhg6co2_eibuMs2ghkGOxyE0ZtfFwZIfMaQhemF7JfdYu_D4-a2JxKoIjFo6Li5tlH22EMCYl3MftybsYmF3A3VXtsqIgR9WtOEjO9AKXXa-_LBkEGK5btM02aWf-ls7cOmOxIJD1"
        width="100%"
        height="500"
        // id="myId"
        // className="myClassname"
        frameBorder="0"
        scrolling="auto"
        allowfullscreen={true}
        style="display: block;margin-left: auto;margin-right: auto;max-width: 100%;"
        // display="inline" // Changed by Chris from "initial" to "inline"
        // position="relative"
      />

      {/* <NewsletterTitle // Below : original newsletter handling via MailChimp API - SHOULD BE DELETED (comment from Chris)
      >
        Subscribe to our newsletter and <br /> stay updated.
      </NewsletterTitle>

      <NewsletterInputWrapper onSubmit={handleSubmit}>
        {success ? (
          <SuccessMessage>{success} 🙂</SuccessMessage>
        ) : (
          <InputWrapper>
            <Input
              type="email"
              name="email"
              placeholder="Write your email here"
              onChange={handleChange}
              value={email}
              required
            />
            <Button title="Subscribe" type="submit" />
          </InputWrapper>
        )}

        {error && (
          <ErrorMessage
            dangerouslySetInnerHTML={{ __html: `<span>*</span>${error}` }}
          />
        )}
      </NewsletterInputWrapper> */}
    </NewsletterWrapper>
  );
};

export default Newsletter;
